import HeroSection from "../components/code/HeroSection";
import PotentialSection from "../components/code/PotentialSection";
import TalentLaunchSection from "../components/code/TalentLaunchSection";
import DreamJourneySection from "../components/code/DreamJourneySection";
import StatsSection from "../components/code/StatsSection";
import HolisticDevelopmentSection from "../components/code/HolisticDevelopmentSection";
import GlobalImpactSection from "../components/code/GlobalImpactSection";
import TrainingCooperationSection from "../components/code/TrainingCooperationSection";
import FloatingContactButtons from "../components/common/FloatingContactButtons";

import RevealSection from "../components/common/RevealSection";

function CodePage() {
  return (
    <div className="code-page">
      <HeroSection />
      <RevealSection delay={0.1}>
        <PotentialSection />
      </RevealSection>
      <RevealSection delay={0.2}>
        <TalentLaunchSection />
      </RevealSection>
      <RevealSection delay={0.3}>
        <DreamJourneySection />
      </RevealSection>
      <RevealSection delay={0.4}>
        <StatsSection />
      </RevealSection>
      <RevealSection delay={0.5}>
        <HolisticDevelopmentSection />
      </RevealSection>
      <RevealSection delay={0.6}>
        <GlobalImpactSection />
      </RevealSection>
      <RevealSection delay={0.7}>
        <TrainingCooperationSection />
      </RevealSection>
      <FloatingContactButtons />
    </div>
  );
}

export default CodePage;
